import useBreakpoint from 'antd/lib/grid/hooks/useBreakpoint';
import { BookDummy } from 'assets';
import BestSellerSvg from 'assets/Icons/Text/BestSellerSvg';
import ComingSoonSVG from 'assets/Icons/Text/ComingSoonSVG';
import FreeSvg from 'assets/Icons/Text/FreeSvg';
import NewSvg from 'assets/Icons/Text/NewSvg';
import TopTenIcon from 'assets/Icons/TopTenIcon';
import clsx from 'clsx';
import Image from 'next/image';
import Link from 'next/link';

import { ShouldRender } from '@/components/shared/basic/ShouldRender';

export interface BooksSliderProps {
  coverImage: string;
  title: string;
  tag?: string;
  topTen?: string;
  slug: string;
  id: string;
  isFree: boolean;
  isExternalLink?: boolean;
  externalLink?: string;
  bookCount?: number;
  courseCount?: number;
  main_price?: number;
  stroked_price?: number;
}

interface BookCardProps {
  book: BooksSliderProps;
  notBookLandingPage?: boolean;
  isAddToCart?: boolean;
  className?: string;
}

const BookCardHome = ({ book, className }: BookCardProps) => {
  const screens = useBreakpoint();

  const getInternalHref = () => {
    if (book.tag === 'COMING SOON') {
      return `/bundles/${book.slug}-${book.id}/`;
    } else if (book.isFree) {
      return `/bundles/${book.slug}-${book.id}/?short=true`;
    } else {
      return `/bundles/${book.slug}-${book.id}/`;
    }
  };

  const href =
    (book.isFree ? book.isExternalLink : !book.isExternalLink) &&
    book.externalLink
      ? book.externalLink
      : getInternalHref();
  const isExternal =
    (book.isFree ? book.isExternalLink : !book.isExternalLink) &&
    !!book.externalLink;

  const tagSvgMap: Record<string, JSX.Element> = {
    free: (
      <FreeSvg
        width={screens.md ? '23' : '17'}
        height={screens.md ? '8' : '6'}
      />
    ),
    new: (
      <NewSvg
        width={screens.md ? '23' : '17'}
        height={screens.md ? '8' : '6'}
      />
    ),
    bestseller: (
      <BestSellerSvg
        width={screens.md ? '55' : '41'}
        height={screens.md ? '8' : '6'}
      />
    ),
    'coming soon': (
      <ComingSoonSVG
        width={screens.md ? '67' : '51'}
        height={screens.md ? '8' : '6'}
      />
    ),
  };

  // const strokedPrice = book.stroked_price || 0;
  // const mainPrice = book.main_price || 0;

  // const discountPercentage =
  //   strokedPrice > 0
  //     ? Math.round(((strokedPrice - mainPrice) / strokedPrice) * 100)
  //     : 0;

  return (
    <Link
      href={href}
      passHref
      target={isExternal ? '_blank' : undefined}
      rel={isExternal ? 'noopener noreferrer' : undefined}
      className='h-full flex-1 flex w-full'
    >
      <div className='flex justify-center flex-1 flex-col w-full'>
        <div
          className={clsx(
            'border border-stroke rounded-xl flex flex-col justify-between h-full relative transition-transform duration-300 ease-in-out group-hover:scale-[1.02]',
            className || '2xl:w-[304px] xl:w-[250px] lg:w-[250px] md:w-[220px] sm:w-[180px] w-[180px]',
          )}
        >
          <Image
            src={book.coverImage || BookDummy}
            alt={book.title}
            width={screens.md ? 320 : 200}
            height={screens.md ? 250 : 160}
            className={clsx(
              'rounded-t-[12px] transition-transform transform duration-500 z-20 relative self-center',
              'w-full aspect-[14/11]',
            )}
            style={{ objectFit: 'cover' }}
          />
          <div className='2xl:p-5  xl:p-4  lg:p-4  md:p-3  sm:p-2.5  p-2.5 flex flex-col justify-between flex-1'>
            <div>
              <p className='text-grayZl-500 2xl:text-[14px]/[22px] xl:text-[12px]/[20px] lg:text-[12px]/[20px] md:text-[12px]/[20px] sm:text-[10px]/[18px] text-[10px]/[18px] font-medium mb-1'>
                {book.bookCount
                  ? book.bookCount + ' Book' + (book.bookCount > 1 ? 's' : '')
                  : ''}
                {book.bookCount && book.courseCount ? ' + ' : ''}
                {book.courseCount
                  ? book.courseCount +
                    ' Course' +
                    (book.courseCount > 1 ? 's' : '')
                  : ''}
              </p>
              <p className='text-white 2xl:text-[18px]/[26px] xl:text-[16px]/[24px] lg:text-[16px]/[24px] md:text-[14px]/[22px] sm:text-[12px]/[20px] text-[12px]/[20px] font-bold mb-1 line-clamp-2'>
                {book.title}
              </p>
            </div>
            {/* <div>
              <p className='flex gap-1 items-center'>
                <p className='text-sm/[22px] font-medium line-through text-grayZl-700'>
                  {book.stroked_price ? '₹' + book.stroked_price : ''}
                </p>
                <p className='font-bold text-base/6 text-white'>
                  {book.main_price ? '₹' + book.main_price : ''}
                </p>
                <RenderIf condition={!!discountPercentage}>
                  <div className='flex items-center '>
                    <p className='text-sm/[22px] text-success-600 font-bold'>
                      {discountPercentage}%
                    </p>
                    <BiSolidDownArrowCircle className='text-success-600 w-5 h-5' />
                  </div>
                </RenderIf>
              </p>
              <RenderIf condition={isAddToCart}>
                <div className='px-6 mb-6'>
                  <Button
                    size={0}
                    variant={ButtonVariants.WHITE}
                    className='font-semibold text-sm/[22px] py-[10px] w-full '
                  >
                    Add to Cart
                  </Button>
                </div>
              </RenderIf>
            </div> */}
          </div>
          <ShouldRender
            check={
              book.tag &&
              !book.topTen &&
              book.tag?.toLowerCase() !== 'bestseller'
            }
          >
            <div
              style={{ boxShadow: '0px 4px 4px 0px #00000040' }}
              className={clsx(
                `absolute top-0 right-0 p-[5px] rounded-bl-[4px] rounded-tr-[4px] font-bold leading-[12px] text-[9px] tracking-[-0.02em] uppercase`,
                {
                  'bg-white ': book.tag?.toLowerCase() === 'bestseller',
                  'bg-[#DC2626] ': book.tag?.toLowerCase() === 'new',
                  'bg-[#280845] ': book.tag?.toLowerCase() === 'coming soon',
                  'bg-primary ': ![
                    'bestseller',
                    'new',
                    'coming soon',
                    'free',
                  ].includes(book.tag?.toLowerCase() || ''),
                },
              )}
            >
              {tagSvgMap[book.tag?.toLowerCase() || ''] ?? book.tag}
            </div>
          </ShouldRender>

          <ShouldRender check={book.isFree}>
            <div
              style={{
                boxShadow: '0px 4px 4px 0px #00000040',
                background: 'linear-gradient(180deg, #282829 0%, #121212 100%)',
              }}
              className='absolute top-0 left-0 p-[5px]   text-[10px] font-bold  leading-[12px] tracking-[-0.02em] text-white rounded-br-[4px] rounded-tl-[4px]'
            >
              {tagSvgMap['free']}
            </div>
          </ShouldRender>

          <ShouldRender check={book.topTen}>
            <div
              style={{
                clipPath: 'polygon(0 0, 100% 0%, 100% 100%, 0 83%)',
                backgroundColor: '#FF5A1F',
                boxShadow: '0px 4px 4px 0px #00000040',
              }}
              className='absolute top-0 right-0 px-1 pt-1 pb-[8px] text-white font-bold text-[10px] rounded-tr-[4px] z-20'
            >
              <div className='flex flex-col items-center leading-tight'>
                <TopTenIcon />
              </div>
            </div>
          </ShouldRender>
        </div>
      </div>
    </Link>
  );
};

export default BookCardHome;
